import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=0cb2ae02&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=0cb2ae02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2ae02",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2Announcement: require('/app/components/Theme2/Announcement.vue').default,Theme2DesktopFloatingIconsRankingButton: require('/app/components/Theme2/Desktop/FloatingIcons/RankingButton.vue').default})
